<template>
<div>
    <page-title-bar></page-title-bar>
    <app-section-loader :status="loader"></app-section-loader>
    <v-container fluid grid-list-xl pt-0>
        <v-layout row wrap justify-center>
            <v-flex xs12 md11>
                <app-card pt-0>
                    <v-card-title>
                        <h4>BÁO CÁO NỢ TIỀN PHÒNG CHƯA THU</h4>
                        <v-spacer></v-spacer>
                        <v-layout row justify-end>
                            <v-flex xs12 md4>
                                <v-text-field
                                v-model="search"
                                prepend-icon="search"
                                label="Tìm kiếm"
                                single-line
                                hide-details
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md4>
                                <v-select
                                    label="Tòa nhà"
                                    :disabled="loading.submit"
                                    v-model="chosen_building"
                                    :items="list_building"
                                    prepend-icon="domain"
                                    required
                                    single-line
                                    hide-details
                                ></v-select>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        :rows-per-page-items="rowPerPage"
                    >
                        <template #headers="props">
                            <tr>
                                <th :class="`text-xs-${header.align} fw-bold`" v-for="header in props.headers" :key="header.text">
                                    {{ header.text }}
                                </th>
                            </tr>
                        </template>
                        <template #items="props">
                            <td class="text-center text-no-wrap">{{ props.item.dateCreate }}</td>
                            <td class="text-center">{{ props.item.room_id }}</td>
                            <td class="text-center">{{ props.item.room_bill | formatNumber }}</td>
                            <td class="text-center">{{ props.item.cash | formatNumber }}</td>
                            <td class="text-center">{{ props.item.bank | formatNumber }}</td>
                            <td class="text-center">{{ props.item.bank_tranfer | formatNumber }}</td>
                            <td class="text-center">{{ props.item.diff | formatNumber }}</td>
                            <td class="text-center">{{ props.item.bank_name }}</td>
                            <td class="text-center">{{ props.item.note }}</td>
                        </template>
                    </v-data-table>
                </app-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import api from "Api";

export default {
    data() {
        return {
            loader: false,
            search:'',
            headers: [
                { text: "Ngày", align: "center", value: "dateCreate" },
                { text: "Số Phòng", align: "center", value: "room_id" },
                { text: "Chứng từ", align: "center", value: "paper_id" },
                { text: "Diễn giải", align: "center", value: "explain" },
                { text: "Thu", align: "center", value: "revenue" },
                { text: "Ghi chú", align: "center", value: "note" },
                { text: "Người thu", align: "center", value: "collecter" },
                { text: "Ngày thu", align: "center", value: "date_collect" },
                { text: "Chứng từ", align: "center", value: "paper_id_2" },
                { text: "Tiền phòng", align: "center", value: "room_bill" },
                { text: "Tiền mặt", align: "center", value: "cash" },
                { text: "Còn phải chuyển", align: "center", value: "bank" },
                { text: "Thực chuyển", align: "center", value: "bank_tranfer" },
                { text: "Chênh lệch", align: "center", value: "diff" },
                { text: "Tên NH", align: "center", value: "bank_name" },
                { text: "Nội dung chuyển khoảng", align: "center", value: "note" },
            ],
            list_building: [
                {text: 'Bảo Ngọc', value: 'BN'},
                {text: 'Gia Bảo', value: 'GB'},
                {text: 'Thanh Tâm', value: 'TT'},
                {text: 'Xuân Anh', value: 'XA'},
                {text: 'Mai Anh', value: 'MA'},
                {text: 'Tất cả', value: ''},
            ],
            chosen_building: 'BN',
            items: [],
            loading: {
                submit: false
            },
            rowPerPage: [20,50,100,{"text":"Tất cả","value":-1}]
        };
    },
    mounted() {
        this.getTablesData();
    },
    methods: {
        getTablesData() {
            let dummy_data = [
                {
                    room_id: '101GB',
                    dateCreate: '31/03/2019',
                    dateCreate: '31/03/2019',
                    dateCreate: '31/03/2019',
                    room_bill:   2611000,
                    cash:   0,
                    diff:   0,
                    bank:   2611000,
                    bank_tranfer:   2611000,
                    bank_name:   'VCB',
                    note: '',
                },
            ]
            for (let index = 0; index < 7; index++) {
                const element = dummy_data[0];
                this.items.push(element)
            }
        }
    }
};
</script>
